<template>
  <div class="main-body">
    <div v-if="isShowStandard">
      <card-header :data="headerData"></card-header>
      <card-modules
        :standardData="standardData"
        :data="modulesData"
      ></card-modules>
      <dd-card title="商品规格">
        <template #body>
          <dd-card-table :list="skuSpecList"></dd-card-table>
        </template>
      </dd-card>
    </div>

    <DDLost v-else :errorDesc="errorDesc" :errorType="showType" />
  </div>
</template>

<script>
import CardHeader from "@/components/QualityStandard/CardHeader.vue";
import CardModules from "@/components/QualityStandard/CardModules.vue";
import DdCard from "@/components/DdCard.vue";
import DdCardTable from "@/components/DdCardTable.vue";
import http from "@/utils/request.js";
import DDLost from "@/views/Lost.vue";
import { qmsUrl } from "@/config";

export default {
  name: "QualityStandard",
  components: { CardHeader, CardModules, DDLost, DdCard, DdCardTable },
  data() {
    return {
      headerData: {},
      modulesData: [],
      standardData: [],
      standardId: "",
      showType: "none-info", // loading, normal，301，404
      errorDesc: "当前商品无验收标准",
      isShowStandard: true,
      skuSpecList: [] // 商品规则
    };
  },
  created() {
    // 解析url   http://trace.te.test.srv.mc.dd/#/qualitystandard?skuId=151
    // const tempUrl = `http://localhost:8080/#/qualitystandard?skuId=151`;
    const params = this.$route.query;
    const { skuId } = params;
    // @todo 应当补充错误提示，等重构时引入第三方toast
    this.getQualityStandardData(skuId);
  },
  methods: {
    async getQualityStandardData(skuId) {
      const params = { skuId };
      const detailUrl = `${qmsUrl}/qms-service/api/standard/v2/detail`;
      // const detailUrl = "https://yapi.corp.100.me/mock/151/standard/v2/detail";
      const resp = await http.post(detailUrl, params);
      const { datas = {}, success } = resp;
      if (success) {
        this.headerData = {
          name: datas.name,
          code: datas.code,
          version: datas.version
        };
        this.modulesData = datas.modules;
        this.standardData = datas.item;

        // 商品规格单独显示
        this.skuSpecList = this.formatSkuSpecList(
          datas.skuSpecTitleVo,
          datas.skuSpecValueVoList
        );
      } else {
        this.isShowStandard = false;
      }
    },
    // 格式化商品规则数据
    formatSkuSpecList(columnTitle = {}, columnValue = []) {
      const _temp = [];
      const columnTitlePrefix = "specTitle"; // 列标题前缀
      const columnValuePrefix = "specValue"; // 列内容前缀
      columnValue.forEach((valueItem, index) => {
        const seq = `序号${index + 1}`;
        const contents = [];
        Object.keys(columnTitle).forEach((title, index) => {
          contents.push({
            columnName: columnTitle[`${columnTitlePrefix}${index + 1}`],
            columnContent: valueItem[`${columnValuePrefix}${index + 1}`]
          });
        });
        _temp.push({ seq, contents });
      });

      return _temp;
    }
  }
};
</script>

<style lang="less">
.card-title {
  height: 48px;
  line-height: 48px;
  background: #33c658;
  color: white;
  text-align: center;
}
</style>
